import { render } from "./long-insure-bills.vue?vue&type=template&id=6d65b329&scoped=true&ts=true"
import script from "./long-insure-bills.vue?vue&type=script&lang=ts"
export * from "./long-insure-bills.vue?vue&type=script&lang=ts"

import "./long-insure-bills.vue?vue&type=style&index=0&id=6d65b329&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d65b329"]])

export default __exports__